module.exports = __webpack_public_path__ + "img/logo.660018a0.png";